import type { ReactNode } from 'react';
import { cx } from './cx.js';

/**
 * A section on a configuration page: title, optional description, an actions
 * slot on the right of the header, and the body. Replaces five hand-rolled
 * section shapes (an <h3 className="sec-head"> followed by whatever each pane
 * felt like) with one, so section rhythm stops being per-pane.
 */
export function Card({
  id,
  title,
  description,
  actions,
  status,
  className,
  children,
}: {
  /** an anchor: a header item can deep-link to this card (/configuration/ingest#email-pending). */
  id?: string | undefined;
  title?: ReactNode | undefined;
  description?: ReactNode | undefined;
  actions?: ReactNode | undefined;
  status?: ReactNode | undefined;
  className?: string | undefined;
  children: ReactNode;
}) {
  return (
    <section id={id} className={cx('ui-card', className)}>
      {title || actions || status ? (
        <header className="ui-card__head">
          <div className="ui-card__title">
            <h3>{title}</h3>
            {status}
          </div>
          {actions ? <div className="ui-card__actions">{actions}</div> : null}
        </header>
      ) : null}
      {description ? <p className="ui-card__desc">{description}</p> : null}
      <div className="ui-card__body">{children}</div>
    </section>
  );
}

/** A row of actions. Replaces `.btn-row`, which doubled as a form wrapper. */
export function Toolbar({
  children,
  className,
}: {
  children: ReactNode;
  className?: string | undefined;
}) {
  return <div className={cx('ui-toolbar', className)}>{children}</div>;
}
